import {AccountMin} from "platformed-client/types";
import {platformedClient} from "..";

export async function listRegions(account: AccountMin) {
  return await platformedClient.externalRequest(
    "get",
    `/region/{region}/external_api/accounts/{account_id}/portal_discovery/regions`,
    {path: {region: account.region, account_id: account.account_id}},
  );
}

export async function listPortals(account: AccountMin, region: string) {
  return await platformedClient.externalRequest(
    "get",
    `/region/{region}/external_api/accounts/{account_id}/portal_discovery/portals`,
    {path: {region, account_id: account.account_id}},
  );
}
